// utils
import {
  characterWalk
} from '@/assets/js/utils/characterWalk'
import {
  characterSpeech
} from '@/assets/js/utils/characterSpeech'
import {
  createBlinkAnimation
} from '@/assets/js/utils/createBlinkAnimation'
import {
  updateText
} from '@/assets/js/utils/updateText'

// character animations
import {
  reeceAnimations
} from '@/assets/js/characters/reeceAnimations'
import {
  haileyAnimations
} from '@/assets/js/characters/haileyAnimations'
import {
  devynAnimations
} from '@/assets/js/characters/devynAnimations'
import {
  riaAnimations
} from '@/assets/js/characters/riaAnimations'
import {
  ayeAnimations
} from '@/assets/js/characters/ayeAnimations'

const reece = reeceAnimations()
const hailey = haileyAnimations()
const devyn = devynAnimations()
const ria = riaAnimations()
const aye = ayeAnimations()

//- export later -//

import anime from 'animejs'

const animateBackDrop = (ctx, options, arr) => { // method to animate backdrop
  arr = arr || []
  options.int = options.int || 1200
  options.duration = options.duration || 8000
  arr.push(anime({
    targets: '.library-backdrop, #school_hall_empty_outer, #school_hall_empty_outer_second',
    translateX: `-${ctx.backDropTranslate + options.int}px`,
    duration: options.duration,
    easing: 'linear',
    complete: () => {
      ctx.backDropTranslate += options.int // preserve backdrop position
    }
  }))
}

//- -//

const slides = []
const walkingAnimations = []
let preventAdditionalLoops = false

const addSlide = (slide) => {
  slides.push(slide)
}

//- all slides -//

addSlide((ctx) => { // Slide 1 (index 0)
  let schoolHallway = new Audio('static/audio/module_3/schoolHallway.mp3')
  schoolHallway.volume = 0.5
  schoolHallway.play()
  ctx.modalInd += 1 // increment pop-in modal text
  ctx.controlPanelActive = false
  aye.enter()
  ria.enter({
    complete: () => {
      ria.raiseRightArm()
      characterSpeech(ctx.riaData, 4)
      updateText(ctx, true)
      ctx.controlPanelActive = true
    }
  })
  devyn.enter()
  createBlinkAnimation("devyn")
  createBlinkAnimation("hailey")
  createBlinkAnimation("reece")
})

addSlide((ctx) => { // 2
  ctx.controlPanelActive = false
  ria.lowerRightArm()
  devyn.raiseRightArm({
    handshake: true,
    complete: () => {
      ctx.ayeData = ['smile', 'green']
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.devynData, 4)
  updateText(ctx, true, "Devyn")
})

addSlide((ctx) => { // 3 (handshake)
  ctx.controlPanelActive = false
  devyn.handShake()
  aye.handShake({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  updateText(ctx, true)
})

addSlide((ctx) => { // 4
  ctx.controlPanelActive = false
  devyn.wink()
  devyn.lowerRightArm({
    delay: 750
  })
  aye.lowerRightArm({
    delay: 900,
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.devynData, 4)
  updateText(ctx, true, "Devyn")
  setTimeout(() => {
    ctx.ayeData = ["neutral", "yellow"]
  }, 1000)
})

addSlide((ctx) => { // 5
  ctx.controlPanelActive = false
  updateText(ctx, true)
  aye.scratchHead({
    complete: () => {
      devyn.laugh()
      ria.laugh({delay: 150})
      aye.lowerLeftArm({
        complete: () => {
          ctx.ayeData = ["neutral", "yellow"]
          ctx.controlPanelActive = true
        }
      })
    }
  })
  ctx.ayeData = ["unsure", "orange"]
})

addSlide((ctx) => { // 6 and 7
  ctx.controlPanelActive = false
  // ria.wave({
    // complete: () => {
      ria.exit({
        delay: 500
      })
  //   }
  // })
  // devyn.wave({
  //   delay: 250,
  //   complete: () => {
      setTimeout(() => {
        updateText(ctx, true, "Devyn") // 7 starts here
        devyn.raiseRightArm({
          half: true,
          complete: () => {
            ctx.controlPanelActive = true
          }
        })
        characterSpeech(ctx.devynData, 4)
      }, 750)
    // }
  // })
})

addSlide((ctx) => { // 8
  ctx.controlPanelActive = false
  updateText(ctx, true)
  devyn.lowerRightArm()
  aye.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  ctx.ayeData = ["smile", "green"]
})

addSlide((ctx) => { // 9
  ctx.controlPanelActive = false
  aye.lowerLeftArm()
  devyn.rotate({
    flipped: true
  })
  ctx.devynData.look_back = true
  devyn.raiseRightArm({
    delay: 500,
    begin: () => {
      updateText(ctx, true, "Devyn")
      characterSpeech(ctx.devynData, 4)
    },
    complete: () => {
      ctx.controlPanelActive = true
      devyn.lowerRightArm({
        delay: 1000
      })
    }
  })
})

addSlide((ctx) => { // 10 and 11 consolidated
  ctx.controlPanelActive = false
  ctx.devynData.look_back = false
  devyn.exit({
    complete: () => { // 11
      updateText(ctx, true)

      // todo: fix this to work with an empty backrop.
      // todo: make this a loop that pauses and plays.
      
      animateBackDrop(ctx, {
        int: 1200,
        duration: 10000,
      }) 

      aye.walkInPlace({
        duration: 10000,
        begin: () => { // show popup modal
          // ctx.modalActive = true
          // ctx.modalLayerClass = ''
          // todo: additional logic HERE.
          ctx.openModalLayer()
        }
      })
      reece.rotate({
        flipped: true
      })
      reece.slideIn({
        delay: 8000,
        complete: () => {
          ctx.controlPanelActive = true
        }
      })
      hailey.slideIn({
        delay: 8000
      })
    }
  })
})

addSlide((ctx) => { // 12 (finished walking, says hello)
  ctx.controlPanelActive = false
  // ctx.modalActive = false // hide modal
  // ctx.modalLayerClass = 'layer-inactive'
  ctx.closeModalLayer()
  updateText(ctx, true)
  aye.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  reece.rotate({
    delay: 1500
  })
})

addSlide((ctx) => { // 13
  ctx.controlPanelActive = false
  updateText(ctx, true, "Hailey")
  aye.lowerLeftArm({
    delay: 150
  })
  hailey.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.haileyData, 4)
})

addSlide((ctx) => { // 14
  ctx.controlPanelActive = false
  updateText(ctx, true)
  hailey.lowerLeftArm({
    delay: 150
  })
  aye.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})

addSlide((ctx) => { // 15
  ctx.controlPanelActive = false
  updateText(ctx, true, "Reece")
  aye.lowerLeftArm()
  reece.raiseRightArm({
    full: true,
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.reeceData, 4)
})

addSlide((ctx) => { // 16 (all characters start walking here) 
  ctx.controlPanelActive = false
  hailey.rotate({
    flipped: true
  })
  hailey.headRotate({
    flipped: true,
    delay: 150,
    complete: () => {
      updateText(ctx, true, "Hailey")
      hailey.raiseRightArm({
        complete: () => {
          ctx.controlPanelActive = true
        }
      })
      characterSpeech(ctx.haileyData, 4)
    }
  })
  reece.lowerRightArm()
  reece.rotate({
    flipped: true,
  })
  reece.headRotate({
    flipped: true,
    delay: 750
  })

  //- walking animation to take place throughout the rest of slides -//
  const walkDuration = (8000 * 12)

  walkingAnimations.push(anime({
    targets: "#aye",
    translateY: characterWalk(walkDuration),
    duration: walkDuration,
    easing: "linear",
    loop: true
  }))

  walkingAnimations.push(anime({
    targets: '#hailey',
    right: {
      value: ['5%', '32%'],
      duration: 10000
    },
    scaleX: {
      value: -1,
      duration: 1
    },
    translateY: characterWalk(walkDuration, 15),
    easing: 'linear',
    delay: 100,
    duration: walkDuration,
    complete: () => { // run loop on complete
      walkingAnimations.push(anime({
        targets: "#hailey",
        scaleX: {
          value: -1,
          duration: 1
        },
        translateY: characterWalk(walkDuration, 15, 950), // move up and down
        duration: walkDuration,
        easing: "linear",
        loop: true
      }))
    }
  }))

  walkingAnimations.push(anime({
    targets: '#reece',
    scaleX: {
      value: -1,
      duration: 1
    }, // flip reece
    right: {
      value: ['20%', '45%'],
      duration: 10000
    }, // gradually move closer to center of scene
    translateY: characterWalk(walkDuration, 12, 1100), // move up and down
    duration: walkDuration,
    easing: 'linear',
    delay: 150,
    complete: () => {
      walkingAnimations.push(anime({
        targets: '#reece',
        scaleX: {
          value: -1,
          duration: 1
        },
        translateY: characterWalk(walkDuration, 12, 1100), // move up and down
        duration: walkDuration,
        easing: "linear",
        loop: true
      }))
    }
  }))


  // animate backdrop
  animateBackDrop(ctx, {
    int: (6568 - 1200),
    duration: walkDuration,
  }, walkingAnimations)

  // LOOP empty backdrop
  setTimeout(() => {
    if(!preventAdditionalLoops) { // loop additional background SVGs if bell did not ring.
      walkingAnimations.push(anime({
        targets: "#school_hall_empty, #school_hall_empty_second",
        translateX: '-5704px',
        easing: 'linear',
        duration: walkDuration,
        loop: true
      }))
    }
  }, walkDuration)

  //- -//

})

addSlide((ctx) => { // 17
  ctx.controlPanelActive = false
  updateText(ctx, true, "Reece")
  hailey.lowerRightArm()
  reece.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  reece.headRotate({
    flipped: false
  })
  characterSpeech(ctx.reeceData, 4)
})

addSlide((ctx) => { // 18
  ctx.controlPanelActive = false
  updateText(ctx, true, "Aye")
  aye.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  reece.headRotate({
    flipped: true,
    delay: 150
  })
  reece.lowerLeftArm()
  ctx.ayeData = ["neutral", "green"]
})

addSlide((ctx) => { // 19 (artboard 21)
  ctx.controlPanelActive = false
  updateText(ctx, true, "Hailey")
  aye.lowerLeftArm()
  hailey.raiseLeftArm()
    .raiseRightArm({
      complete: () => {
        ctx.controlPanelActive = true
        ctx.ayeData = ["smile", "green"]
      }
    })
  characterSpeech(ctx.haileyData, 4)
})

addSlide((ctx) => { // 20
  ctx.controlPanelActive = false
  updateText(ctx, true, "Aye")
  hailey.lowerLeftArm()
    .lowerRightArm()
  aye.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})

addSlide((ctx) => { // 21
  ctx.controlPanelActive = false
  updateText(ctx, true, "Reece")
  aye.lowerLeftArm({
    delay: 150,
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  reece.raiseLeftArm()
  characterSpeech(ctx.reeceData, 4)
})

addSlide((ctx) => { // 22
  ctx.controlPanelActive = false
  updateText(ctx, true, "Hailey")
  reece.lowerLeftArm()
  hailey.raiseRightArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.haileyData, 3)
})

addSlide((ctx) => { // 23 (artboard 25, 'didn't romeo and juliet die?')
ctx.controlPanelActive = false
  updateText(ctx, true)
  hailey.lowerRightArm()
  aye.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  ctx.ayeData = ["unsure", "orange"]
})

addSlide((ctx) => { // 24
  ctx.controlPanelActive = false
  updateText(ctx, true, "Reece")
  aye.lowerLeftArm()
  reece.raiseRightArm()
  characterSpeech(ctx.reeceData, 4)
  setTimeout(() => {
    ctx.ayeData = ["smile", "green"]
    ctx.controlPanelActive = true
  }, 500)
})

addSlide((ctx) => { // 25 (artboard 27, 'true love is like destiny...')
  ctx.controlPanelActive = false
  updateText(ctx, true, "Hailey")
  reece.lowerRightArm()
  hailey.raiseRightArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.haileyData, 4)
})

addSlide((ctx) => { // 26 (artboard 28)
  ctx.controlPanelActive = false
  updateText(ctx, true, "Reece")
  hailey.lowerRightArm()
  reece.raiseLeftArm({
    complete: () =>{
      ctx.controlPanelActive = true
    }
  })
  reece.headRotate({
    flipped: false
  })
  characterSpeech(ctx.reeceData, 4)
})

addSlide((ctx) => { // 27 (29)
  ctx.controlPanelActive = false
  updateText(ctx, true, "Hailey")
  reece.lowerLeftArm()
  reece.headRotate({
    flipped: true
  })
  hailey.raiseLeftArm()
  hailey.raiseRightArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.haileyData, 4)
})

addSlide((ctx) => { // 28 (30)
  ctx.controlPanelActive = false
  updateText(ctx, true)
  hailey.lowerLeftArm()
  hailey.lowerRightArm()
  aye.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  ctx.ayeData = ["neutral", "orange"]
})

addSlide((ctx) => { // 29 (31)
  ctx.controlPanelActive = false
  updateText(ctx, true, "Reece")
  aye.lowerLeftArm()
  reece.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  reece.headRotate({
    flipped: false
  })
  characterSpeech(ctx.reeceData, 4)
})

addSlide((ctx) => { // 30 (32)
  ctx.controlPanelActive = false
  updateText(ctx, true, "Hailey")
  reece.lowerLeftArm()
  reece.headRotate({
    flipped: true
  })
  hailey.raiseLeftArm()
  hailey.raiseRightArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.haileyData, 4)
})

addSlide((ctx) => { // 31 (33, 'are you not whole?')
  ctx.controlPanelActive = false
  updateText(ctx, true)
  hailey.lowerLeftArm()
  hailey.lowerRightArm()
  aye.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  ctx.ayeData = ["unsure", "orange"]
})

addSlide((ctx) => { // 32 (34)
  ctx.controlPanelActive = false
  updateText(ctx, true, "Hailey")
  aye.lowerLeftArm()
  hailey.raiseRightArm({
    complete: () => {
      ctx.ayeData = ["neutral", "orange"]
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.haileyData, 4)
})

addSlide((ctx) => { // 33 (35)
  ctx.controlPanelActive = false
  updateText(ctx, true)
  hailey.lowerRightArm()
  aye.raiseLeftArm({
    complete: () => {
      ctx.ayeData = ["smile", "green"]
      ctx.controlPanelActive = true
    }
  })
})

addSlide((ctx) => { // 34 (36)
  ctx.controlPanelActive = false
  updateText(ctx, true, "Reece")
  aye.lowerLeftArm()
  reece.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.reeceData, 4)
})

addSlide((ctx) => { // 35 (37)
  ctx.controlPanelActive = false
  updateText(ctx, true)
  reece.lowerLeftArm()
  ctx.ayeData = ["neutral", "orange"]
  aye.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})

addSlide((ctx) => { // 34 (38)
  ctx.controlPanelActive = false
  updateText(ctx, true, "Reece")
  aye.lowerLeftArm()
  reece.raiseRightArm({
    complete: () => {
      ctx.ayeData = ["smile", "orange"]
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.reeceData, 4)
})

addSlide((ctx) => { // 35 (39)
  ctx.controlPanelActive = false
  updateText(ctx, true, "Reece")
  reece
    .lowerRightArm()
    .raiseLeftArm({
      complete: () => {
        ctx.controlPanelActive = true
      }
    })
    .headRotate({
      fliped: false
    })
  characterSpeech(ctx.reeceData, 4)
})

addSlide((ctx) => { // 36 (40, 'is love only for couples?')
ctx.controlPanelActive = false
  updateText(ctx, true)
  reece.lowerLeftArm()
    .lowerRightArm()
    .headRotate({
      flipped: true
    })
  ctx.ayeData = ["neutral", "orange"]
  aye.scratchHead({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})

addSlide((ctx) => { // 37 (41)'
  ctx.controlPanelActive = false
  updateText(ctx, true, "Hailey")
  aye.lowerLeftArm()
  hailey.raiseLeftArm({
    complete: () => {
      ctx.ayeData = ["smile", "green"]
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.haileyData, 4)
})

addSlide((ctx) => { // 38 (42)
  ctx.controlPanelActive = false
  updateText(ctx, true)
  hailey.lowerLeftArm()
  aye
    .raiseLeftArm()
    .raiseRightArm({complete: () => {
      ctx.controlPanelActive = true
    }})
})

addSlide((ctx) => { // 39 (43)
  ctx.controlPanelActive = false
  updateText(ctx, true, "Hailey")
  aye.lowerLeftArm().lowerRightArm()
  hailey.raiseRightArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.haileyData, 4)
})

addSlide((ctx) => { // 40 (45, skipped popup modal)
  ctx.controlPanelActive = false
  updateText(ctx, true, "Reece")
  hailey.lowerRightArm()
  reece.headRotate({
    flipped: false
  })
  reece.raiseRightArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  characterSpeech(ctx.reeceData, 4)
})

addSlide((ctx) => { // 41 (46, 'thanks guys')
  ctx.controlPanelActive = false
  updateText(ctx, true)
  reece.lowerRightArm().headRotate({
    flipped: true
  })
  aye
    .raiseLeftArm()
    .raiseRightArm({
      complete: () => {
        ctx.controlPanelActive = true
      }
    })
})


addSlide((ctx) => { // 42 (47, 'first bell rings for class')
  let schoolBell = new Audio('static/audio/module_3/schoolBell.wav')
  schoolBell.volume = 0.5
  schoolBell.play()
  preventAdditionalLoops = true // set prevent flag to true
  ctx.controlPanelActive = false
  updateText(ctx, false) // don't update text

  // pause walking and background movement
  walkingAnimations.forEach((animation) => {
    animation.pause()
  })


  aye.lowerLeftArm().lowerRightArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
  reece.headRotate({
    flipped: false
  })
  hailey.headRotate({
    flipped: false
  })
  ctx.ayeData = ["unsure", "orange"]
  ctx.haileyData.look_up = true
  ctx.reeceData.look_up = true
})

addSlide((ctx) => { // 43 (48)
  ctx.controlPanelActive = false
  updateText(ctx, true)
  ctx.ayeData = ["smile", "green"]
  reece.headRotate({
    flipped: true
  })
  hailey.headRotate({
    flipped: true
  })
  ctx.haileyData.look_up = false
  ctx.reeceData.look_up = false
  aye.raiseLeftArm({
    complete: () => {
      ctx.controlPanelActive = true
    }
  })
})

addSlide((ctx) => { // 44 (49, 'bye, aye')
  ctx.controlPanelActive = false
  aye.lowerLeftArm({
    complete: () => {
      aye.exit()
      // animateBackDrop(ctx, {
      //   int: 100,
      //   duration: 4000
      // })
      anime({
        targets: '.library-backdrop, #school_hall_empty_outer, #school_hall_empty_outer_second',
        translateX: "-=100px",
        duration: 4000,
        easing: "linear"
      })
      anime({ // push hailey and reece back 100px with backdrop
        targets: "#hailey, #reece",
        translateX: "-=100px",
        scaleX: {
          value: -1,
          duration: 1
        },
        duration: 4000,
        easing: "linear"
      })
    }
  })

  // maybe move to next slide.

  hailey.headRotate({
    flipped: false,
    delay: 4000
  })
  reece.headRotate({
    flipped: false,
    delay: 4150
  })

  setTimeout(() => { // easier to read than setting individual delays on everything.
    ctx.controlPanelActive = true
    updateText(ctx, true, "Hailey")
    reece.raiseRightArm({
      wave: true,
      delay: 250,
      begin: () => {
        characterSpeech(ctx.reeceData, 2)
      },
      complete: () => {
        reece.lowerRightArm()
        delay: 300
      }
    })
    hailey.wave()
    characterSpeech(ctx.haileyData, 2)
  }, 6000)

})

addSlide((ctx) => { // 45 (50, added additional popup modal)
  updateText(ctx, false)
  ctx.controlPanelActive = false
  // ctx.modalLayerClass = ""
  // ctx.modalActive = true
  ctx.openModalLayer()
  ctx.modalInd += 1 // increment pop-in modal text
  setTimeout(() => {
    ctx.controlPanelActive = true
  }, 5000)
})

addSlide((ctx) => { // 46 doors close
  // ctx.modalActive = false
  // ctx.controlPanelActive = false
  ctx.closeModalLayer()
})

//- -//

export {
  slides
}



// WEBPACK FOOTER //
// ./src/components/module_3/js/slides.js